import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, formValueSelector, change } from 'redux-form'
import moment from 'moment'
import Toggler from 'hoc/toggler'
import DatePicker from 'react-datepicker'
import CheckBoxField from 'forms/shared/fields/checkbox'
import 'react-datepicker/dist/react-datepicker.css'

// State-controlled dropdown (used primaryl by public pages form)
const DatePickerDropdown = ({
  input,
  isOpen,
  toggle,
  placeholder = 'Select a date',
  groupClassName,
  inputClassName = 'text-sm text-primary-dark',
  placeholderClassName = 'text-sm',
  errorClassName,
  meta: { touched, error },
  showIcon = false,
  showText = true,
  showUncertain = false,
  pickerClassName = '',
  boxClassName = 'w-full border rounded-lg p-3 cursor-pointer',
  disabled,
  dispatch,
  formName
}) => {
  const [startDate, setStartDate] = useState(input.value)

  useEffect(() => {
    if (disabled) {
      input.onChange('')
      setStartDate('')
      toggle()
    }
  }, [disabled])

  const renderNotSureYet = () => (
    <div className="flex items-center justify-center">
      <Field
        type={'checkbox'}
        name={'uncertain'}
        label={'I’m not sure yet'}
        groupClassName="w-max"
        labelClassName={'block text-gray-700 text-sm w-max'}
        inputClassName={'shadow-sm rounded-none border text-gray-700 leading-tight focus:border-0 focus:outline-none focus:shadow-outline'}
        inputErrorClassName={'border-action-danger'}
        errorClassName={errorClassName}
        component={CheckBoxField}
      />
    </div>
  )

  const renderDatePicker = () => (
    <div className={`border border-primary-orange rounded-lg mt-3 ${pickerClassName}`}>
      <div className="flex justify-center">
        <DatePicker
          {...input}
          minDate={new Date()}
          selected={startDate}
          onChange={date => {
            if (disabled && formName) dispatch(change(formName, 'uncertain', false))
            input.onChange(date)
            setStartDate(date)
            toggle()
          }}
          calendarClassName="react-datepicker-removed-border-version"
          dateFormat="MMMM-d-YYYY"
          inline
        />
      </div>
      {showUncertain && isOpen && renderNotSureYet()}
    </div>
  )

  return (
    <div className={groupClassName}>
      <div className={`${boxClassName} ${isOpen ? 'border-primary-orange' : ''}`}>
        <div className="flex w-full justify-between items-center" onClick={toggle}>
          {showIcon && <i className="fa fa-calendar pr-2" aria-hidden="true"></i>}
          {startDate
            ? <p className={inputClassName}>{moment(startDate, 'MMMM D, YYYY').format('dddd, MMMM D')}</p>
            : <p className={disabled ? inputClassName : placeholderClassName}>{disabled ? 'I’m not sure yet' : placeholder}</p>
          }
          {showText && <span className={`text-xs ${isOpen ? 'text-primary-lightgray' : 'text-primary-orange'}`}>
            Select a date
          </span>}
        </div>
      </div>
      {isOpen && renderDatePicker()}
      {touched && error && <p className={errorClassName}>{error}</p>}
    </div>
  )
}

DatePickerDropdown.propTypes = {
  options: PropTypes.array,
  input: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  inputClassName: PropTypes.string,
  groupClassName: PropTypes.string,
  placeholderClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  meta: PropTypes.object.isRequired,
  showIcon: PropTypes.bool,
  showText: PropTypes.bool,
  showUncertain: PropTypes.bool,
  pickerClassName: PropTypes.string,
  boxClassName: PropTypes.string,
  disabled: PropTypes.bool,
  dispatch: PropTypes.func,
  formName: PropTypes.string
}

const mapStateToProps = ({ ...state }, { formName }) => {
  let selector
  if (formName) selector = formValueSelector(formName)
  return {
    disabled: selector ? selector(state, 'uncertain') : false
  }
}

export default Toggler(connect(mapStateToProps)(DatePickerDropdown))
